'use client';

import { c as _c } from "react/compiler-runtime";
import AppDock from '@/components/AppDock';
import Timeline from './_components/SleepTimeline';
export default function SleepPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative h-screen w-full overflow-hidden bg-neutral-900"><h1 className="sr-only">Sleep Timeline</h1><Timeline /><AppDock /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}